// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__oeGgk","modalFooterButton":"ModalNotes_modalFooterButton__fGX6-"};